import { Roles as RolesDto } from '@electricjs/core_entity-client';

import { OrganizationUserRoleSlugs } from '@/types/users';

export const mockRoles: RolesDto = {
  roles: [
    {
      id: 'role-hub-user-id',
      name: 'Hub User',
      slug: OrganizationUserRoleSlugs.HUB_USER,
    },
    {
      id: 'role-super-admin-id',
      name: 'Super Admin',
      slug: OrganizationUserRoleSlugs.SUPER_ADMIN,
    },
    {
      id: 'role-product-support-id',
      name: 'Product Support',
      slug: OrganizationUserRoleSlugs.PRODUCT_SUPPORT,
    },
  ],
};
